const CHROME_EXTENSION_ID = process.env.VITE_APP_CHROME_EXTENSION_ID;

export const CHROME_EXTENSION_ORIGIN = `chrome-extension://${CHROME_EXTENSION_ID}`;

// Window event the extension's content script listens for to navigate the
// Dugout side panel from Homebase (see extension/src/content_script.ts).
export const DUGOUT_SEND_ACTION_EVENT = 'dugout:sendAction';

export enum ChromeExtensionMessages {
  DOMAIN_CHANGED = 'DOMAIN_CHANGED',
  DUGOUT_LOADED = 'DUGOUT_LOADED',
  EXTRACT_STATE = 'EXTRACT_STATE',
  NAVIGATE_ACTIVE_TAB = 'NAVIGATE_ACTIVE_TAB',
  NEW_ACTION = 'NEW_ACTION'
}

// First extension release that handles NAVIGATE_ACTIVE_TAB; older ones ignore it
export const NAVIGATE_ACTIVE_TAB_MIN_EXTENSION_VERSION = '6.9.0';

export enum DugoutLocations {
  ACTIVITY_LOG = 'ACTIVITY_LOG',
  ENCOUNTERS = 'ENCOUNTERS',
  ENCOUNTER = 'ENCOUNTER',
  ENCOUNTER_BILLING = 'ENCOUNTER_BILLING',
  CMS1500 = 'CMS1500',
  PEOPLE_SELECTOR = 'PEOPLE_SELECTOR',
  PROFILE = 'PROFILE',
  REWARD_CARDS = 'REWARD_CARDS',
  TASK = 'TASK',
  TRANSACTIONS = 'TRANSACTIONS',
  SCHEDULING = 'SCHEDULING',
  RAW_PATH = 'RAW_PATH'
}

export enum SupportedDomains {
  CANDID = 'CANDID',
  HEALTHIE = 'HEALTHIE',
  HOMEBASE = 'HOMEBASE',
  KUSTOMER = 'KUSTOMER'
}
